module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid footer-wrap"
  }, [_c('div', {
    staticClass: "container footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('div', {
    staticClass: "btn-group mt-20"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.changeLocale('pl')
      }
    }
  }, [_vm._v("PL")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row footer-left"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("footer.columnOneTitle")))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.about")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.contact")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/static/privacy"
    }
  }, [_vm._v(_vm._s(_vm.$t("privacyPolicy")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/static/rules"
    }
  }, [_vm._v(_vm._s(_vm.$t("rules")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/static/mangopay"
    }
  }, [_vm._v(_vm._s(_vm.$t("mangopay")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("footer.columnTwoTitle")))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/start_campaign"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.startCampaign")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/how_it_works"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.howItWorks")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/static/faq"
    }
  }, [_vm._v(_vm._s(_vm.$t("FAQ")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/pricing"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.pricing")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("footer.columnThreeTitle")))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.crowdfunding")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/fundraising"
    }
  }, [_vm._v(_vm._s(_vm.$t("project.fundraising")))])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/profiles"
    }
  }, [_vm._v(_vm._s(_vm.$t("specialists")))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("footer.signUp")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscription.email),
      expression: "subscription.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('footer.email')
    },
    domProps: {
      "value": (_vm.subscription.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscription, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.subscribe()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.signUpButton")))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.subscriptionSuccess))]), _vm._v(" "), _c('h4', {
    staticClass: "follow-us"
  }, [_vm._v(_vm._s(_vm.$t("footer.follow")))]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("do")]), _c('span', {
    staticClass: "domore-blue-1"
  }, [_vm._v("More")]), _c('span', {
    staticClass: "white"
  }, [_vm._v(".live")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Facebook"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-3x"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "Twitter"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-3x"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "Google +"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus-square fa-3x"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "You Tube"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-square fa-3x"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "Linked In"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square fa-3x"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "Instagram"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-3x"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a64330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/Index.vue
// module id = 780
// module chunks = 1